module.exports = __webpack_public_path__ + "e5c81f9217ee084e8496aa96a5b9d2e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/question-banner.jpg
// module id = 1195
// module chunks = 0